import React from 'react';
import { Error } from 'components';

const Page404: React.FC = () => {
  return <Error type="Error404" />
};

export default Page404;
